<div class="sendlane-postscript-container" [class.from-order-review]="isCallFromOrderReviewDeatil" #mainContainer>


  <!-- Filters Section (Fixed Header OUTSIDE scrollable area) -->
   

    <!-- New Timeline Layout -->
    <div class="timeline-wrapper" [class.from-order-review]="isCallFromOrderReviewDeatil" #timelineContainer>
        <div class="timeline-container">
            <div class="figma-timeline">
                <!-- Left Timeline Line -->
                <div class="timeline-sidebar">
                    <div class="timeline-items-sidebar">
                        <div *ngFor="let item of data; let i = index" class="timeline-item-sidebar">
                            <div class="timeline-line-section">
                                <div class="timeline-marker" [ngClass]="{
                                    'marker-success': item.IsCompleted && !item.IsFailed,
                                    'marker-danger': item.IsFailed,
                                    'marker-warning': !item.IsCompleted && !item.IsFailed
                                }">
                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="15" height="15" rx="7.5" fill="#121212"/>
                                    </svg>
                                    
                                </div>
                                <div class="timeline-line" *ngIf="i < data.length - 1"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Right Content Area -->
                <div class="timeline-content">
                    <div class="timeline-items-content">
                        <div *ngFor="let item of data; let i = index" class="timeline-item-content">
                            <div class="figma-card">
                                <!-- Card Header -->
                                <div class="figma-card-header">
                                    <div class="card-title-section">
                                        <h6 class="card-title">{{item.Platform === 'postscript_create' ? 'POSTSCRIPT CREATE' : 'SENDLANE'}}</h6>
                                    </div>
                                    <div class="card-status-section">
                                        <div class="status-badge" [ngClass]="{
                                            'status-completed': item.IsCompleted && !item.IsFailed,
                                            'status-failed': item.IsFailed
                                        }">
                                            {{getStatusText(item)}}
                                        </div>
                                                                                 <div class="info-icon" (click)="viewDetails(item)" style="cursor: pointer;">
                                             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                 <rect width="24" height="24" rx="12" fill="#E6E6E6"/>
                                                 <path d="M12 10C11.7348 10 11.4804 10.1054 11.2929 10.2929C11.1054 10.4804 11 10.7348 11 11V17C11 17.2652 11.1054 17.5196 11.2929 17.7071C11.4804 17.8946 11.7348 18 12 18C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17V11C13 10.7348 12.8946 10.4804 12.7071 10.2929C12.5196 10.1054 12.2652 10 12 10ZM12 6C11.7528 6 11.5111 6.07331 11.3055 6.21066C11.1 6.34801 10.9398 6.54324 10.8452 6.77165C10.7505 7.00005 10.7258 7.25139 10.774 7.49386C10.8223 7.73634 10.9413 7.95907 11.1161 8.13388C11.2909 8.3087 11.5137 8.42775 11.7561 8.47598C11.9986 8.52421 12.2499 8.49946 12.4784 8.40485C12.7068 8.31024 12.902 8.15002 13.0393 7.94446C13.1767 7.7389 13.25 7.49723 13.25 7.25C13.25 6.91848 13.1183 6.60054 12.8839 6.36612C12.6495 6.1317 12.3315 6 12 6Z" fill="black" stroke="black" stroke-width="0.5"/>
                                             </svg>
                                                
                                        </div>
                                    </div>
                                </div>

                                <!-- Card Body -->
                                <div class="figma-card-body">
                                    <div class="email-text">{{item.Email}}</div>
                                    <div class="date-info">
                                        <div class="date-item ">
                                            <span class="date-label email-text">Created:</span>
                                            <span class="date-value">{{item.CreatedDate | date:'MMM dd, yyyy | HH:mm:ss a'}}</span>
                                        </div>
                                        <div class="date-item ">
                                            <span class="date-label email-text">Updated:</span>
                                            <span class="date-value">{{item.UpdatedDate | date:'MMM dd, yyyy | HH:mm:ss a'}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Loading More Indicator -->
        <div class="loading-more-indicator" *ngIf="isLoadingMore">
            <p-progressSpinner strokeWidth="2" [style]="{ width: '20px', height: '20px' }" animationDuration=".5s"></p-progressSpinner>
        </div>
    </div>

    <!-- No Data Message -->
    <div *ngIf="data.length === 0" class="empty-state text-center p-5">
        <i class="pi pi-inbox text-primary mb-4 opacity-75" style="font-size: 4rem"></i>
        <h2 class="text-primary mb-2">No Timeline Events</h2>
        <p class="text-muted mb-0">
            No Sendlane Postscript data is currently available. 
            Try adjusting your filters or refreshing the page.
        </p>
    </div>
</div>

<style>
.sendlane-postscript-container {
    position: relative;
}


.sendlane-postscript-container.from-order-review {
    min-height: fit-content;
}

.fixed-header.filters-section {
    position: sticky;
    top: 0;
    z-index: 10;
    padding: 1rem;
    border-radius: 0.5rem;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.fixed-header.filters-section:not(.from-order-review) {
    background-color: white;
}

.fixed-header.filters-section.from-order-review {
    background-color: #f8fafc;
}

.filter-item {
    min-width: 150px;
}

.filter-button-container {
    position: relative;
}

.btn-action {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    background-color: white;
    font-size: 0.875rem;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-action:hover {
    background-color: #f8f9fa;
}

.btn-action.active-filter {
    border-color: #0d6efd;
    color: #0d6efd;
}

.btn-action i {
    font-size: 0.875rem;
}

/* Ensure consistent button heights */
.btn-outline-secondary {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    line-height: 1.5;
    height: 38px; /* Match p-dropdown height */
}

/* Ensure dropdown alignment */
:host ::ng-deep .p-dropdown {
    height: 38px;
}

:host ::ng-deep .p-dropdown .p-dropdown-label {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}

.timeline-wrapper {
    position: relative;
    padding-top: 0;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
}

.timeline-wrapper:not(.from-order-review) {
    height: calc(100vh - 140px);
    overflow-y: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
}

.timeline-wrapper.from-order-review {
    height: auto;
    max-height: calc(100vh - 140px);
    overflow-y: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
}

/* Hide scrollbar for WebKit browsers (Chrome, Safari, Edge) */
.timeline-wrapper::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background: transparent;
}

.timeline-wrapper::-webkit-scrollbar-track {
    background: transparent;
}

.timeline-wrapper::-webkit-scrollbar-thumb {
    background: transparent;
}

.timeline-wrapper::-webkit-scrollbar-corner {
    background: transparent;
}

.timeline-container {
    min-height: 200px;
    padding-bottom: 2rem;
}

/* New Figma-inspired Timeline Layout */
.figma-timeline {
    display: flex;
    gap: 15px;
    padding: 15px 0 40px;
    align-items: flex-start;
}

.timeline-sidebar {
    padding: 15px 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.timeline-items-sidebar {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.timeline-item-sidebar {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.timeline-line-section {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.timeline-marker {
    width: 15px;
    height: 15px;
    background: #121212;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px 1px;
    gap: 10px;
}

.timeline-marker svg {
    width: 15px;
    height: 15px;
    color: white;
}

.timeline-line {
    width: 1px;
    height: 113px;
    background: #E5E5E5;
}

.timeline-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.timeline-items-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.timeline-item-content {
    width: 100%;
}

/* Figma Card Styles */
.figma-card {
    background: rgba(0, 0, 0, 0.03);
    border-radius: 12px;
    padding: 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-self: stretch;
    gap: 20px;
}

.figma-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    gap: 15px;
}

.card-title-section {
    display: flex;
    align-items: center;
}

.card-title {
    font-family: Lexend, sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 1.25em;
    letter-spacing: 2%;
    color: #232323;
    margin: 0;
}

.card-status-section {
    display: flex;
    align-items: center;
    gap: 10px;
}

.status-badge {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 7px;
    border-radius: 5px;
    font-family: Lexend, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.25em;
         letter-spacing: 2%;
}

.status-badge.status-completed {
     background: #C4EDB9;
     color: #166B00;
}

.status-badge.status-failed {
     background: rgba(255, 0, 0, 0.12);
     color: #9B0000;
}

.info-icon {
     width: 24px;
     height: 24px;
     background: #E6E6E6;
     border-radius: 100px;
     display: flex;
     justify-content: center;
     align-items: center;
     gap: 10px;
     padding: 5px;
}

.info-icon svg {
     width: 24px;
     height: 24px;
     color: #000000;
}

.figma-card-body {
     display: flex;
     flex-direction: column;
     gap: 20px;
}

.email-text {
     font-family: Lexend, sans-serif;
     font-weight: 400;
     font-size: 14px;
     line-height: 1.25em;
     letter-spacing: 2%;
     color: #888888;
     padding-bottom: 4px;
}

.date-info {
     display: flex;
     align-items: center;
     gap: 10px;
}

.date-item {
     font-family: Lexend, sans-serif;
     font-weight: 400;
     font-size: 14px;
     line-height: 1.25em;
     letter-spacing: 2%;
     color: #232323;
}

.date-item.created {
     background: #C4EDB9;
     padding: 7px;
     border-radius: 5px;
}

.date-item.updated {
     background: #FFE4B5;
     padding: 7px;
     border-radius: 5px;
}

.date-label {
     font-weight: 500;
}

.date-value {
     margin-left: 5px;
}



.loading-more-indicator {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
    padding: 5px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.btn-light {
    background-color: #fff;
    border: 1px solid #dee2e6;
    color: #212529;
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    line-height: 1.5;
    height: 38px;
    transition: all 0.2s;
}

.btn-light:hover {
    background-color: #f8f9fa;
    border-color: #dee2e6;
}

.custom-date-dropdown {
    position: absolute;
    top: calc(100% + 5px);
    right: 0;
    margin-top: 0;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    width: 300px;
}

.date-picker-container {
    padding: 1rem;
}

.date-picker-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #e9ecef;
}

.btn-close-picker {
    background: none;
    border: none;
    padding: 0;
    font-size: 0.875rem;
    color: #6c757d;
    cursor: pointer;
}

.btn-close-picker:hover {
    color: #343a40;
}

:host ::ng-deep .small-calendar {
    .p-datepicker {
        width: 100%;
        min-width: unset;
        padding: 0.5rem;
        
        table {
            font-size: 0.875rem;
            margin: 0.5rem 0;
            
            th {
                padding: 0.25rem;
            }
            
            td {
                padding: 0.25rem;
                
                > span {
                    width: 28px;
                    height: 28px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
    }
}

.date-range-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    margin-top: 1rem;
    padding-top: 0.5rem;
    border-top: 1px solid #e9ecef;
}

.btn-apply,
.btn-cancel {
    padding: 0.375rem 1rem;
    font-size: 0.875rem;
    border-radius: 4px;
    border: none;
    cursor: pointer;
}

.btn-apply {
    background-color: #6366f1;
    color: white;
}

.btn-apply:hover {
    background-color: #4f46e5;
}

.btn-cancel {
    background-color: #e9ecef;
    color: #495057;
}

.btn-cancel:hover {
    background-color: #dee2e6;
}
</style> 